/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Tooltip } from '@ouster/webviz-react-components';

import { useState, useEffect, useMemo } from 'react';

import styles from './BarChart.module.css';

type BarChartProps = {
  current: number;
  total: number;
  filledColor: string;
  tooltipVisibility?: boolean;
  tooltipContent?: string;
};

export default function BarChart({
  current,
  total,
  filledColor,
  tooltipVisibility = true,
  tooltipContent,
}: BarChartProps) {
  const [showTooltip, setShowTooltip] = useState(false);

  const usage = useMemo(() => {
    /* 
      when error fetch usage or usage exceed allowance, cap the value to 100
    */
    const percentage =
      total === 0 ? 100 : Math.min(100, Math.round((current / total) * 100));

    return percentage;
  }, [current, total]);

  const filledStyle: any = {
    '--filled': `${usage}%`,
    '--filled-color': filledColor,
  };

  useEffect(() => {
    if (tooltipVisibility) {
      const timeout = setTimeout(() => {
        setShowTooltip(true);
      }, 1000); // Match this with the CSS transition duration (1 second)

      return () => clearTimeout(timeout);
    }
  }, [tooltipVisibility]);

  return (
    <div className={styles['bar-wrapper']} data-testid="bar-chart-wrapper">
      <div className={styles['bar-container']} data-testid="bar-chart-container">
        {tooltipVisibility ? (
          <Tooltip
            label={tooltipContent}
            placement="top-end"
            hasArrow
            isOpen={showTooltip}
            arrowSize={10}
            offset={[-15, 15]}
            className="custom-tooltip"
            sx={{ left: '42px' }}
          >
            <div
              className={styles['used-bar']}
              aria-label="allowed space"
              style={filledStyle} // Set the dynamic width
              data-testid="bar-chart-used-bar"
            />
          </Tooltip>
        ) : (
          <div
            className={styles['used-bar']}
            aria-label="allowed space"
            style={filledStyle} // Set the dynamic width
            data-testid="bar-chart-used-bar"
          />
        )}
      </div>
    </div>
  );
}
